module.exports = __webpack_public_path__ + "img/footer-img.png?da899d04413f1c3988ec5828114c1743";